<template>
    <v-card class="score-chart ma-1">
        <v-container>
            <v-card flat class="ma-1 pt-2 pl-2 pr-2 transp" style="padding-bottom: 5px;">
                    <div  style="display: flex; flex-direction: row; align-items: center;">
                        <div>
                            <v-card-title class="caption-font">Accommodation status
                                <v-spacer></v-spacer><span class="intro-font"><b>{{this.title}}</b></span>
                            </v-card-title>
                            <v-card-subtitle>You have {{ accocount }} accommodation online.</v-card-subtitle>
                        </div>
                        <div style="display: grid; grid-template-columns: 4fr 1fr; border: 1px solid; font-size: x-small; padding: 2px; padding-right: 6px; padding-left: 6px; border-radius: 6px; margin-left: 16px;">
                            <div>With error</div>
                            <div class="ml-auto" style="color: red; font-weight: 700;">{{ err }}</div>
                            <div>With warning</div>
                            <div class="ml-auto" style="color: orange; font-weight: 700;">{{ wrn }}</div>
                            <div>Total listed</div>
                            <div class="ml-auto" style="font-weight: 500;">{{ accocount }}</div>
                        </div>  
                        <div style="margin-left: auto; margin-right: 20px !important" v-if="accocount!==0">
                            <span v-if="err===0&&wrn===0" class="flex"><v-icon size="50" color="success">mdi-emoticon-happy-outline</v-icon><div class="jury-report aok">Everything looks okay...</div></span>
                            <span v-if="err===0&&wrn!==0" class="flex"><v-icon size="50" color="warning">mdi-emoticon-wink-outline</v-icon><div class="jury-report wrn">Only warnings, good enough</div></span>
                            <span v-if="err!==0" class="flex"><v-icon size="50" color="error">mdi-emoticon-sad-outline</v-icon><div class="jury-report err">Accos with errors found!</div></span>
                        </div>
                    </div>
                    <div  style="display: flex; flex-direction: row; align-items: center; width: fit-content; gap: 20px; margin-left: 16px;">
                        <select_notification :selected_notification="notification" field="notification" label="Notification" :isClearable="true" @updateData="updateData" style="width: 200px;"/>
                        <div style="font-size: small;">Found {{this.filtered_accos.length}} results </div>
                    </div>
                    <div v-if="filtered_accos.length!==0" style="margin-left: 16px;">
                        <div v-if="err!==0||wrn!==0">
                            <div class="grid gridheader scrollbar-gutter">
                                <div class="gridheadercol"></div>
                                <div class="gridheadercol" >Acco ({{ listed }})</div>
                                <div class="gridheadercol" >Description</div>
                                <div class="gridheadercol" >Notifications</div>
                            </div>
                            <ul class="scrollbar-gutter">
                                <li v-for="(acco, idx) in filtered_accos" :key="idx" class="grid">    
                                    <div class="gridcol"><v-icon size="24">mdi-home</v-icon></div>     
                                    <div @click="$router.open('/huis/onHuis/' + acco.encrid)" class="clickable gridcol">{{ acco.acco }}</div>     
                                    <div class="gridcol">{{ acco.oms }}</div>     
                                    <div class="flex gridcol">
                                        <div v-if="acco.err !== 0"><v-avatar size="21" class="mb-1 mr-2 acco-error"> {{ acco.err }} </v-avatar></div>
                                        <div v-if="acco.wrn !== 0"><v-avatar size="21" class="mb-1 acco-warning"> {{ acco.wrn }} </v-avatar></div>
                                    </div>     
                                </li>                                       
                            </ul>        
                        </div>
                        <div v-else>
                            <div style="height: 275px; width: 100%; display: flex; align-items: center; justify-content: center;">
                                <div style="text-align: center; border: 2px solid green; padding: 10px !important; border-radius: 15px; width:fit-content !important">
                                    <div class="flex">
                                        <div style="padding-left: 10px !important; padding-top: 10px !important; padding-right: 20px !important;">
                                            <img src="@/assets/ok2.png" width=80 alt="m.c.sar">
                                        </div>
                                        <div>
                                            <div style="width: 300px; font-size: large; font-weight: 500">You have {{ accocount }} accommodations online and no warnings and no errors.</div>
                                        </div>
                                    </div>
                                </div>                        
                            </div>    
                        </div>
                    </div>
                    <div v-else style="height: 275px; width: 100%; display: flex; align-items: center; justify-content: center;">
                         <div style="text-align: center; border: 1px solid red; padding: 10px !important; border-radius: 15px;"><div>No accommodation status data?</div><div>You may be registered as an agent incorrectly</div><div>notify the <a href="mailto:ares@villaforyou.com">aresbox</a></div></div>                        
                    </div>    
            </v-card>
            <v-card-actions></v-card-actions>
        </v-container>
    </v-card>
</template>

<script>

    import {bus} from "../../../../main";
    import select_notification from '@/components/ui/selectors/select_notification.vue'

    export default {
        components: {            
            select_notification
        },        
        data() {
            return {
                title: '',
                accos: [],
                accocount: 0,
                err: 0,
                wrn: 0,
                listed: 0,
                search: '',
                notification: 'ALL'
            }
        },
        created(){ // set up event bus listener here on created event
            this.getAccoData();
            bus.$on("refresh", (data) => {
                console.log(data)
                this.getAccoData();                
            });
        },                  
        mounted(){            

        },    
        computed: {
            filtered_accos: function() { // filter on user being active    
                return this.accos.filter(el => {
                    if(this.expert==='') {
                        if (this.notification==='ALL') {
                            return true
                        } else {
                            if(this.notification === "ERR" && el.err !==0 ){
                                return true
                            } else {
                                if(this.notification === "WRN" && el.wrn !==0 ){
                                    return true
                                } else {
                                    return false
                                }       
                            }                     
                        }
                    }
                    else { 
                       if (el.agentcode===this.expert) {
                        if (this.notification==='ALL') {
                            return true
                        } else {
                            if(this.notification === "ERR" && el.err !==0 ){
                                return true
                            } else {
                                if(this.notification === "WRN" && el.wrn !==0 ){
                                    return true
                                } else {
                                    return false
                                }       
                            }                     
                        }                        
                       }
                    }    
                });            
            },
        },        
        methods:{
            updateData(data){
                this[data.field] = data.value;
            },            
            getAccoData(){         
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getAgentAccoStatusv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAccoStats"
                    },
                    })
                    .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.accos = res.data.getAccoStats
                        this.accocount = res.data.header.acco_count
                        this.err = res.data.header.err_count
                        this.wrn = res.data.header.wrn_count
                        this.listed = res.data.header.lst_count
                        // console.log(res.data.getAccoStats)
                    }
                    })
                    
            },                       
        }
    }
</script>

<!-- <style>
.agentaccostatv1 td{
    font-size: small !important;
}
.agentaccostatv1 th{
    font-size: small !important;
}
</style> -->

<style scoped>
    .score-chart {
        background: url('../assets/not_a_sunset.png') !important;
        background-size: cover !important;
    }
    .clickable{
        color: blue !important; 
        text-decoration: underline !important; 
        cursor: pointer;
    }
    .scrollbar-gutter {
        overflow-y: auto;
        scrollbar-gutter: stable;
    }    
    .grid{
        display: grid; 
        grid-template-columns: 45px 130px 4fr 2fr; 
    }    
    .gridcol{    
        padding: 4px;
        border-bottom: 1px solid;
        border-color: lightgray;
        font-size: small;
    }    
    .gridheadercol{    
        padding: 4px;
        border-bottom: 2px solid;
        border-color: lightgray;
        font-weight: 500;
        font-size: small;
    }    
    .transp {
        background-color: transparent !important;
    }
    ul{
        list-style-type: none;
        padding: 0;
        margin: 0;
        height: 205px;
        overflow-y:auto;
    }    
    .flex{
        display: flex;
        flex-direction: row;
        align-items: center;
    }    
    .push-right {
        justify-content: end;
    }
    .acco-error {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;    
        border: 2px solid red;
        color: red;
        cursor:default;
    }
    .acco-warning {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;    
        border: 2px solid orange;
        color: orange;
        cursor:default;
    }      
    .jury-report{
        align-self: flex-end; 
        margin-left: 10px;         
        font-weight: 500;
    }
    .err {
        color: red; 
    }
    .wrn {
        color: orange; 
    }
    .aok{
        color: green; 
    }

</style>